import CommentsList from './comments-list';

export default CommentsList;